export const AddOfferStepsBuckets = {
  0: [
    'name',
    'categories',
    'city',
    'employment_types',
    'description',
    'homeoffice',
    'min_salary',
    'max_salary',
    'date_start',
    'contact_email',
    'contact_phone',
    'contact_name',
    'contact_surname',
    'company_name',
    'address',
    'postcode',
    'country',
  ],
  1: ['skills'],
  2: ['qualification'],
  3: ['languages'],
  4: ['driving_licences'],
};
